import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { ANSWER_TRIVIA } = LOCAL;

export default {
	namespaced: true,
	state: {
		correct: false,
	},
	actions: {
		answer({ commit }, answer) {
			commit(ANSWER_TRIVIA, answer);
		},
		complete({ dispatch, state, rootState }) {
			const { reward, spinPenalty } = rootState.game.bummers.active;

			if (state.correct) {
				dispatch("game/balance/deposit", { amount: reward }, ROOT_FLAG);
			} else {
				dispatch("game/rounds/active/addSpins", { count: spinPenalty }, ROOT_FLAG);
			}
		},
	},
	mutations: {
		[ANSWER_TRIVIA](state, answer) {
			state.correct = answer.correct;
		},
	},
};
